




























































































































































































import { IChannel, IAddChannel } from "@/@types/channels/channels";
import { Component, Prop, Vue } from "vue-property-decorator";
import { validationMixin } from "vuelidate";
import { channelTypes } from "@/config/channels/channel-types.config.json";

import UploadingImageToServer from "../../app/images/uploading-image-to-server.vue";
import SubmitResetButtonGroop from "../../buttons/submit-reset-button-groop.vue";
import BSwitch from "../../app/switchs/b-switch.vue";

import {
  required,
  numeric,
  minValue,
  maxLength,
} from "vuelidate/lib/validators";
import { IContentType } from "@/@types/channels/content-type";

@Component({
  name: "add-channel-form-stream",
  mixins: [validationMixin],
  validations: {
    sourceAddress: { required },
    sort_order: { numeric, minValue: minValue(0) },
    name: { required, maxLength: maxLength(100) },
  },
  components: {
    "upload-pics": UploadingImageToServer,
    submit: SubmitResetButtonGroop,
    BSwitch,
  },
})
export default class AddChannelFormStream extends Vue {
  @Prop({ type: Object, default: null }) channel!: IChannel | null;
  @Prop({ type: String, default: "tv" }) activeType!: string;
  @Prop({ type: Array, default: () => [] }) contentTypes!: Array<IContentType>;

  sourceAddress = "";
  sort_order = 0;
  name = "";
  image = "";
  show = true;
  contentType = "";

  get type(): number {
    const i = channelTypes.findIndex((t) => t == this.activeType);
    return i < 0 ? 1 : i + 1;
  }

  get ch(): Partial<IAddChannel> {
    return {
      _id: this.channel ? this.channel._id : "",
      data: { sourceAddress: this.sourceAddress },
      sort_order: this.sort_order,
      name: this.name,
      image: this.image,
      show: this.show,
      type: this.channel ? this.channel.type : this.type,
    };
  }

  get contentTypeName(): string {
    const ct = this.contentTypes.find((type) => type._id == this.contentType);
    return ct
      ? this.$getLocale(ct.name)
      : String(this.$i18n.t("ChannelsPage.form.contentType.no-type"));
  }

  onSubmit(event: HTMLFormElement): void {
    event.preventDefault();
    this.$emit("update", this.ch);
  }

  onReset(): void {
    this.sourceAddress = "";
    this.sort_order = 0;
    this.name = "";
    this.image = "";
    this.show = true;
  }

  createChennel(): void {
    if (!this.channel) return;
    this.sourceAddress = this.channel.data
      ? this.channel.data.sourceAddress
      : "";
    this.sort_order = this.channel.sort_order;
    this.name = this.channel.name;
    this.image = this.channel.image;
    this.show = this.channel.show;
  }

  mounted(): void {
    this.createChennel();
  }
}
